export default __webpack_public_path__ + "static/media/icon-phone.918ee601.svg";